import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

export default class extends PureComponent {
  static propTypes = {
  }
  static defaultProps = {
  }
  state = {
  }
  // ======================================================
  // Commit Phase
  // Can work with DOM, run side effects, schedule updates.
  // ======================================================
  componentDidMount = () => {
  }
  componentDidUpdate = (prevProps, prevState, snapshot) => {
  }
  componentWillUnmount = () => {
  }
  // ======================================================
  // Pre-commit Phase
  // Can read the DOM
  // ======================================================
  getSnapshotBeforeUpdate = (prevProps, prevState) => {
    return {}
  }
  // ======================================================
  // Render Phase
  // Pure and no side effects. May be paused, aborted or restarted by React.
  // ======================================================
  static getDerivedStateFromProps (props, state) {
    return {}
  }
  // ======================================================
  // Private Methods
  // ======================================================
  handleChange = (e) => {
    console.log('handleChange', e.target.value)
    // const { name, onChange } = this.props
    // onChange(name, value)
  }
  renderOptions = () => {
    const { options } = this.props
    return options.map((option, i) => {
      return <option key={option.value} value={option.value}>{option.label || `Option ${i + 1}`}</option>
    })
  }
  render() {
    return (
      <div>
        <select onChange={this.handleChange}>
          {this.renderOptions()}
        </select>
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/InputField/Select/index.js